var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select-pt',{attrs:{"name":"dadoBancarioBanco","value":_vm.modelValue,"options":_vm.banco,"reduce":function (option) { return option.id; },"label":"nome"},on:{"input":function (value) {
      _vm.$emit('update:modelValue', value)
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }